import { HOST, } from "common/constants";
import { Box } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import PaginationComponent from "components/UI/Pagination/PaginationComponent";
import DecreesCard from "../DecreesCard/DecreesCard";
import Empty from "components/Empty/Empty";

import classes from "./decreesList.module.scss";

const SubDecreesList = () => {
  const [acts, setActs] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const offset = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${HOST}/api/v1/act-simple/`, {
          params: { limit: offset, offset: (page - 1) * offset }
        });
        setActs(res.data.results);
        setCount(res.data.count);
      } catch (err) {
        console.error("Ошибка при загрузке act-simple:", err);
      }
    };

    fetchData();
  }, [page]);

  const lengthItems = Math.ceil(count / offset);

  return (
    <>
      <Box className={classes.wrapper}>
        {acts.length > 0 ? (
          acts.map((item, i) => (
            <DecreesCard
              key={i}
              number={item.act_number}
              text={item.title}
              link={item.link}
              acts
            />
          ))
        ) : (
          <Empty />
        )}
      </Box>
      <PaginationComponent page={page} setPage={setPage} length={lengthItems} />
    </>
  );
};

export default SubDecreesList;
